module.exports = __webpack_public_path__ + "static/media/08.9e9e8f9b.wav";